/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateMessageForOfferModel,
  ICreateMessageForOfferRequest,
  IMappers,
  ICreateMessageForOfferResponse,
  ICreateMessageForOfferResponseError,
  TCreateMessageForOfferResponse,
} from './types';

const defaultConfig: TCreateMessageForOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v2/create-message-for-offer/',
  hostType: 'api',
} as TCreateMessageForOfferModel;

function createCreateMessageForOfferModel(parameters: ICreateMessageForOfferRequest): TCreateMessageForOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateMessageForOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateMessageForOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateMessageForOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateMessageForOfferOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCreateMessageForOfferResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCreateMessageForOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateMessageForOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateMessageForOfferResponseError);
    }
  }

  return { response, statusCode } as TCreateMessageForOfferResponse;
}

export { defaultConfig, createCreateMessageForOfferModel, fetchCreateMessageForOffer };
